import { importProvidersFrom } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { StateStorageModule } from '../store-persist/state-storage.module';
import { UiManagerEffects } from './ui-manager.epic';
import { uiStateReducer } from './ui-manager.reducer';
import { uiFeatureKey } from './ui-manager.state';
import { UiStateSaver } from './ui-state-storage';

export function provideUiManager() {
    return [
        provideState(uiFeatureKey, uiStateReducer),
        provideEffects([UiManagerEffects]),
        importProvidersFrom(StateStorageModule.forFeature(uiFeatureKey, UiStateSaver)),
    ];
}
